import { Component, OnInit } from '@angular/core';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { CokyTableColumn } from 'src/app/modules/shared/imports/components/table/table.component';
import { TimeAgoPipe } from 'time-ago-pipe';
import { CierreService } from '../services/cierre.service';

@Component({
  selector: 'app-cierre',
  templateUrl: './cierre.component.html',
  styleUrls: ['./cierre.component.scss']
})
export class CierreComponent implements OnInit {

  tareasNocturno: any[] = []
  selectedTareaNocturno: any[] = []
  columnasTareasNocturno: CokyTableColumn[] = [
    //"ejecutar", "estado", "ult_ejec", "nom_proc", "descrip", "mens_ok"
    { name: "cod_proc", title: "COD" },
    { name: "ejecutar", title: "Ejecutar" },
    { name: "estado", title: "Estado" },
    { name: "ult_ejec", title: "Hora", render: value => this.timeAgoPipe.transform(value) },
    { name: "mens_ok", title: "Mensaje" },
    { name: "nom_proc", title: "Proceso" },
    { name: "descrip", title: "Descripcion" },
  ]


  constructor(
    private cierreService: CierreService,
    private helpers: HelpersService,
    private timeAgoPipe: TimeAgoPipe
  ) { }

  async refresh() {
    await this.getTareasNocturno()
  }

  async ngOnInit() {
    await this.refresh()
  }

  async getTareasNocturno() {
    this.tareasNocturno = []
    showSpinner()
    const result = await this.cierreService.getTareasNocturno()
    hideSpinner()
    if (result.success) {
      this.tareasNocturno = result.data
    }
  }

  async getTareaNocturno(cod_proc: string) {
    showSpinner()
    const result = await this.cierreService.getTareaNocturno(cod_proc)
    hideSpinner()
    return result
  }

  async selectNocturno(selected: any[]) {
    const result = await this.getTareaNocturno(selected[0].cod_proc)
    this.helpers.notifications.infoDialog(selected[0].cod_proc, this.print(result.data), "OK", undefined, "100%", "70vh")
  }

  print(value): string {
    return JSON.stringify(value)
  }
}